import { Storybook } from "@tento-ui/ui/storybook";
import { TurnKvGrid } from "./kv-grid";

export class TurnKvGridStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · kv-grid";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "A session envelope",
        render: () =>
          TurnKvGrid.makeWith({
            pairs: [
              ["session", "afb69f67-2c41-4e00-839b-da6dc00671ed"],
              ["lane", "opencode"],
              ["cwd", "/Users/james/workspace/tento"],
              ["model", "claude-opus-5"],
            ],
          }),
      },
      {
        title: "One pair",
        render: () =>
          TurnKvGrid.makeWith({ pairs: [["exit", "0"]] }),
      },
      {
        title: "A long value wraps in its own column, keys stay aligned",
        render: () =>
          TurnKvGrid.makeWith({
            pairs: [
              ["path", "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes/session-detail.ts"],
              ["bytes", "10696"],
            ],
          }),
      },
      {
        title: "A long key does not squeeze the values",
        render: () =>
          TurnKvGrid.makeWith({
            pairs: [
              ["parent_lineage_id", "legacy:16734:1785895224023052"],
              ["id", "16734"],
            ],
          }),
      },
      {
        title: "Empty",
        render: () => TurnKvGrid.makeWith({ pairs: [] }),
      },
    ];
  }
}
